import React from "react";
import Desktop from "./dekstop";
import Mobile from "./mobile";

const ListReview = (props) => {

	const prop = props;

	if (prop.isMobile) {

		return (
			<Mobile
				{...prop}
			/>
		);

	}
	return (
		<Desktop {...prop} />
	);

};

export default ListReview;
